<template>
    <span
        v-if="disabled"
        v-tooltip.bottom="tooltipTextValue"
        class="inline-block admin-tooltip-wrapper"
        data-admin-tooltip="true"
    >
        <slot />
    </span>
    <span v-else class="inline-block">
        <slot />
    </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    disabled?: boolean
    tooltipText?: string | null
}>()

const { t } = useI18n()

const tooltipTextValue = computed(() => {
    if (!props.disabled) return ''
    return props.tooltipText ?? t('shared.admin_only_tooltip')
})
</script>

<style scoped>
.admin-tooltip-wrapper {
    pointer-events: auto;
}

.admin-tooltip-wrapper :deep(button[disabled]),
.admin-tooltip-wrapper :deep(button.p-disabled),
.admin-tooltip-wrapper :deep(a.p-disabled) {
    pointer-events: none;
}
</style>
